const Config = require('Config');

const Mixpanel = {
  init(options) {
    window.mixpanel && window.mixpanel.init(Config.mixpanel.usersToken);
    Mixpanel.register({ product: options.product });
  },
  register(data) {
    for (const key in data) {
      Mixpanel.unregister(key);
    }
    window.mixpanel && window.mixpanel.register(data);
  },
  unregister(key) {
    window.mixpanel && window.mixpanel.unregister(key);
  },
  track(event, data) {
    window.mixpanel && window.mixpanel.track(event, data || {});
  },
  reset() {
    window.mixpanel && window.mixpanel.reset();
  },
  set(data) {
    window.mixpanel && window.mixpanel.people.set(data);
  },
  identify(id) {
    window.mixpanel && window.mixpanel.identify(id);
  },
};

export default Mixpanel;
